import { Link } from "react-router-dom";
import { XCircle, ArrowRight } from "lucide-react";

export default function CheckoutCancelPage() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6" data-testid="cancel-page">
      <div className="max-w-md w-full card-surface p-10 text-center">
        <XCircle className="mx-auto mb-6 text-zinc-400" size={32} />
        <div className="overline mb-2">Checkout cancelled</div>
        <h1 className="font-display text-3xl mb-3">No worries.</h1>
        <p className="text-zinc-500 mb-8">
          Your account is unchanged. You can pick a plan whenever you're ready.
        </p>
        <Link to="/#pricing" className="btn-primary justify-center w-full" data-testid="cancel-back-pricing">
          Back to pricing <ArrowRight size={16} />
        </Link>
      </div>
    </div>
  );
}
